import { Bounce, toast } from 'react-toastify'
import './alert.scss'

type ErrorResponseShape = {
  response?: {
    data?: {
      error?: string
      message?: string
      errors?: Array<{
        field?: string
        value?: unknown
        errors?: string[]
      }>
    }
  }
}

const isErrorResponseShape = (error: unknown): error is ErrorResponseShape =>
  typeof error === 'object' && error !== null && 'response' in error

const getErrorMessage = (error: unknown) => {
  if (!isErrorResponseShape(error)) {
    return error instanceof Error ? error.message : 'Something went wrong'
  }

  const responseData = error.response?.data
  const validationMessage = responseData?.errors?.flatMap((item) => item.errors ?? []).find(Boolean)

  return validationMessage || responseData?.error || responseData?.message || 'Something went wrong'
}

export const handleSuccess = (text: string) => {
  toast(text, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
    transition: Bounce,
    icon: (
      <svg width='32' height='32' viewBox='0 0 32 32' fill='none'>
        <circle cx='16' cy='16' r='16' fill={'#2AAB61'} />
        <path d='M9 16l4 4 10-10' stroke='#fff' strokeWidth='2' fill='none' />
      </svg>
    ),
    style: {
      borderLeft: '5px solid  #2AAB61',
      minWidth: '400px',
      fontSize: '14px',
    },
  })
}

export const handleError = (error: unknown) => {
  toast(getErrorMessage(error), {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
    transition: Bounce,
    icon: (
      <svg width='32' height='32' viewBox='0 0 32 32' fill='none'>
        <circle cx='16' cy='16' r='16' fill={'#ff0c0c'} />
        <path d='M9 16l4 4 10-10' stroke='#fff' strokeWidth='2' fill='none' />
      </svg>
    ),
    style: {
      borderLeft: '5px solid #ff0c0c',
      minWidth: '400px',
      fontSize: '14px',
    },
  })
}

export const handleLoading = (message: string) => {
  return toast.loading(message, {
    position: 'top-right',
    autoClose: false,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 50 50'
        fill='none'
      >
        <circle
          cx='25'
          cy='25'
          r='20'
          stroke='#2AAB61'
          strokeWidth='5'
          strokeLinecap='round'
          fill='none'
        >
          <animateTransform
            attributeName='transform'
            type='rotate'
            from='0 25 25'
            to='360 25 25'
            dur='1s'
            repeatCount='indefinite'
          />
        </circle>
      </svg>
    ),
    style: {
      borderLeft: '5px solid #2AAB61',
      minWidth: '320px',
      fontSize: '14px',
    },
  })
}
